<template>
  <div id="app">
    <template v-if="layout">
      <div class="containers">
        <div class="left-block hidden-xs hidden-print">
          <div>
            <ul class="nav">
              <li>
                <router-link :to="{name: 'reservations'}" class="navigatable" exact>
                  <div>
                    <span class="icon pe-7s-date"></span>
                    <span>Overview</span>
                  </div>
                </router-link>
              </li>

              <li>
                <router-link :to="{name: 'breakfasts'}" class="navigatable">
                  <div>
                    <span class="icon pe-7s-wine"></span>
                    <span>Breakfasts</span>
                  </div>
                </router-link>
              </li>

              <li v-if="isAdmin">
                <router-link :to="{name: 'rooms.available'}" class="navigatable">
                  <div>
                    <span class="icon pe-7s-unlock"></span>
                    <span>Available rooms</span>
                  </div>
                </router-link>
              </li>

              <li>
                <router-link :to="{name: 'cleaning'}" class="navigatable">
                  <div>
                    <span class="icon pe-7s-door-lock"></span>
                    <span>Cleaning</span>
                  </div>
                </router-link>
              </li>

              <li v-if="isAdmin">
                <router-link :to="{name: 'reporting'}" class="navigatable">
                  <div>
                    <span class="icon pe-7s-graph"></span>
                    <span>Reporting</span>
                  </div>
                </router-link>
              </li>

              <li v-if="isAdmin">
                <router-link :to="{name: 'statistics'}" class="navigatable">
                  <div>
                    <span class="icon pe-7s-graph3"></span>
                    <span>Danmarks Statistik</span>
                  </div>
                </router-link>
              </li>

              <li v-if="isAdmin">
                <router-link :to="{name: 'products'}" class="navigatable">
                  <div>
                    <span class="icon pe-7s-cart"></span>
                    <span>Products</span>
                  </div>
                </router-link>
              </li>

              <li v-if="isAdmin">
                <router-link :to="{name: 'rooms'}" class="navigatable">
                  <div>
                    <span class="icon pe-7s-home"></span>
                    <span>Rooms</span>
                  </div>
                </router-link>
              </li>

              <li v-if="isAdmin">
                <router-link :to="{name: 'settings'}" class="navigatable">
                  <div>
                    <span class="icon pe-7s-tools"></span>
                    <span>Settings</span>
                  </div>
                </router-link>
              </li>

              <li v-else>
                <a @click="signOut" class="navigatable">
                  <div>
                    <span class="icon pe-7s-tools"></span>
                    <span>Sign out</span>
                  </div>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div class="right-block">
          <router-view />
        </div>

        <reservation-overlay></reservation-overlay>
      </div>

      <!-- Search -->
      <div class="search-container hidden-print visible-lg visible-md">
        <search></search>
      </div>
    </template>

    <router-view v-else></router-view>

    <key-navigation></key-navigation>
  </div>
</template>

<script>
    import Search from '@/components/search/Search'
    import KeyNavigation from '@/components/navigation/KeyNavigation'
    import PageBackground from '@/components/layout/PageBackground'
    import ReservationOverlay from '@/components/reservations/Overlay'
    import {mapGetters, mapActions} from 'vuex'

    require('video.js/dist/video-js.css')
    require('vue-video-player/src/custom-theme.css')

    export default {
        name: 'app',

        data() {
            return {
                layout: false
            }
        },

        watch: {
            '$route'() {
                this.updateLayoutSettings()
            }
        },

        computed: {
            ...mapGetters({
                identity: 'authGetIdentity'
            }),

            role() {
                if (!this.identity) {
                    return false
                }

                return this.identity.role
            },

            isAdmin() {
                return this.role === 'admin'
            },

            isCleaner() {
                return this.role === 'admin'
            }
        },

        mounted () {
            this.updateLayoutSettings()
        },

        methods: {
            ...mapActions({
                signOut: 'authSignOut'
            }),

            updateLayoutSettings() {
                let layout = true

                const $router = this.$root.$router

                if ($router.currentRoute) {
                    const currentRoute = $router.currentRoute

                    if (currentRoute.meta.hasOwnProperty('layout')) {
                        layout = currentRoute.meta.layout
                    }
                }

                this.layout = layout
            }
        },

        components: {
            Search,
            KeyNavigation,
            PageBackground,
            ReservationOverlay
        }
    }
</script>

<style lang="scss">
  @import url('https://fonts.googleapis.com/css?family=Lato:300,400,600,700');
  @import url('https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css');
  @import url('https://cdn.bootcss.com/pixeden-stroke-7-icon/1.2.3/dist/pe-icon-7-stroke.min.css');
  @import url('~bootstrap/dist/css/bootstrap.css');

  @import url('https://maxcdn.bootstrapcdn.com/bootswatch/3.3.7/flatly/bootstrap.min.css');
  @import url('~eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.css');
  @import url('~vue-multiselect/dist/vue-multiselect.min.css');

  html, body {
    margin: 0;
    padding: 0;
    height: 100%;

    &.locked {
      overflow: hidden;
    }
  }

  @media print {
    body {
      -webkit-print-color-adjust: exact !important;
    }
  }

  #app {
    font-family: 'Lato', sans-serif;
    min-height: 100vh;
  }

  h1.headline {
    font-size: 24px;
    font-weight: 600;
  }

  .containers {
    width: 100%;
    height: 100%;
    min-height: 100vh;

    display: flex;
    flex-flow: row;
    align-items: stretch;

    > div {
      &.left-block {
        min-width: 110px;
        background-color:#f3f3f3;

        ul.nav {
          list-style: none;

          li {
            position: relative;
            text-align: center;

            a {
              display: flex;
              align-items: center;
              justify-content: center;

              color: #000;
              width: 110px;
              height: 110px;
              font-size: 10px;

              .icon {
                display: block;
                font-size: 25pt;
                margin-bottom: 10px;
              }

              &.active,
              &.router-link-exact-active,
              &:hover {
                color: inherit;
                background-color: rgba(0, 0, 0, 0.2);
              }

              &.navigation-selected-active {
                background-color: rgba(0, 0, 0, 0.1);
              }
            }
          }
        }
      }

      &.right-block {
        position: relative;

        flex: 1 0 auto;

        max-width: 94%;

        background-color: ligthen(#f3f3f3, 20%);

        .page-background {
          overflow: hidden;

          position: absolute;
          z-index: 2;
          left: 0;
          top: 0;

          width: 100%;
          height: 100%;

          padding: 0;

          img {
            max-height: 100%;
          }
        }

        > div {
          position: relative;
          padding: 80px;
          padding-top: 60px;
          z-index: 3;
        }
      }
    }
  }

  .vertical-align {
    display: flex;

    width: 100%;
    min-height: 100%;

    align-items: center;
  }

  .btn {
    border-radius: 3px !important;
    text-transform: uppercase;
    font-weight: 600;
    box-shadow: none;
    letter-spacing: 0.5px;
    outline: 0 !important;

    &.btn-primary,
    &.btn-info,
    &.btn-danger,
    &.btn-default,
    &.btn-warning {
      &:hover {
        background-color: inherit;
      }
    }

    &.btn-primary {
      color: #fff;
      background-color: #de1212;
      border-color: #de1212;

      &:hover,
      &:focus {
        color: #fff;
        background-color: darken(#de1212, 10%);
        border-color: darken(#de1212, 10%);
      }
    }

    &.btn-default {
      color: #fff;
      border-color: #fff;

      &:hover,
      &:focus {
        color: #fff;
        border-color: #fff;
      }

      &.btn-fill {
        color: #333333;
        background-color: #ccc;
        border: 0;
        box-shadow: none;
      }
    }

    &.btn-danger {
      color: #cc1d4b;
      border-color: #cc1d4b;

      &:hover,
      &:focus {
        color: darken(#cc1d4b, 10%);
        border-color: darken(#cc1d4b, 10%);
      }

      &.btn-fill {
        color: #fff;
        background-color: #cc1d4b;
        border: 0;
        box-shadow: none;
      }
    }

    &.navigation-selected-active {
      background-color: rgba(0, 0, 0, 0.1);
    }
  }

  .search-container {
    position: absolute;
    right: 40px;
    top: 40px;
    z-index: 50;
  }

  .tooltip {
    display: block !important;
    padding: 4px;
    z-index: 10000;
    margin-top: -200px;

    .tooltip-inner {
      background: black;
      color: white;
      border-radius: 16px;
      padding: 5px 10px 4px;
    }

    .tooltip-arrow {
      display: none;
    }

    &[aria-hidden='true'] {
      visibility: hidden;
      opacity: 0;
      transition: opacity .15s, visibility .15s;
    }

    &[aria-hidden='false'] {
      visibility: visible;
      opacity: 1;
      transition: opacity .15s;
    }
  }

  .navigation-selected-active {
    background-color: rgba(0, 0, 0, 0.1);
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0
  }

  .slide-fade-enter-active {
    transition: all .5s ease;
  }
  .slide-fade-leave-active {
    transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-enter, .slide-fade-leave-to {
    transform: translateY(10px);
    opacity: 0;
  }

  .toast-container {
    > div {
      color: #3d3d3d;
      font-size: 13px;
      opacity: 1;
      box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
      border-radius: 3px;
      padding: 0;
      width: 400px;
      background-color: #fff;

      &:hover {
        box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
      }

      .toast-title {
        background-color: dimgrey;
        color: #fff;
        font-size: 13px;
        font-weight: 500;
        padding: 15px 25px;
      }

      .toast-message {
        padding: 20px 25px;
        background-color: #fff;
      }

      &.toast-success {
        background-image: none !important;

        .toast-title {
          background-color: transparent;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// App.vue?efa0c286